/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Create_EventInputs */

const en_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Event`)
};

const de_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event erstellen`)
};

const es_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear un evento`)
};

const fr_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un évènement`)
};

const nl_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event maken`)
};

const it_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea evento`)
};

const pt_br2_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar evento`)
};

const pl_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz wydarzenie`)
};

const hu_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esemény létrehozása`)
};

const ro_admin_dashboard_create_event = /** @type {(inputs: Admin_Dashboard_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creati Eveniment`)
};

/**
* | output |
* | --- |
* | "Create Event" |
*
* @param {Admin_Dashboard_Create_EventInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_create_event = /** @type {((inputs?: Admin_Dashboard_Create_EventInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Create_EventInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_create_event(inputs)
	if (locale === "de") return de_admin_dashboard_create_event(inputs)
	if (locale === "es") return es_admin_dashboard_create_event(inputs)
	if (locale === "fr") return fr_admin_dashboard_create_event(inputs)
	if (locale === "nl") return nl_admin_dashboard_create_event(inputs)
	if (locale === "it") return it_admin_dashboard_create_event(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_create_event(inputs)
	if (locale === "pl") return pl_admin_dashboard_create_event(inputs)
	if (locale === "hu") return hu_admin_dashboard_create_event(inputs)
	return ro_admin_dashboard_create_event(inputs)
});
export { admin_dashboard_create_event as "admin.dashboard.create_event" }